import { render, staticRenderFns } from "./LabelAdd.vue?vue&type=template&id=e4b37bbc&"
import script from "./LabelAdd.vue?vue&type=script&lang=js&"
export * from "./LabelAdd.vue?vue&type=script&lang=js&"
import style0 from "./LabelAdd.vue?vue&type=style&index=0&id=e4b37bbc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports